module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/Britannia-S1.57a0daf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/Britannia-S1.jpg
// module id = ZB5M
// module chunks = 0